<template>
  <div class="bg-cream">
    <Nav color="blue" :init-banner-state="true"></Nav>
    <section id="retailers-list" class="padding-main">
      <div class="container-large">
        <h1 class="blue bottom-line">Retailers</h1>
        <div class="grid grid-2">
          <div class="flex col gap-1">
            <div v-for="region in StoresCol1" v-bind:key="region" class="blue region">
              <h2>{{region.regionName}}</h2>
              <div v-for="town in region.towns" v-bind:key="town" class="town">
                <p class="town-name"><i>{{town.townName}}</i></p>
                <div class="flex col">
                  <a v-for="store in town.stores" :href="store.link" v-bind:key="store" class="store-link" target="_blank">{{store.name}}</a>
                </div>
              </div>
            </div>
          </div>
          <div class="flex col gap-1">
            <div v-for="region in StoresCol2" v-bind:key="region" class="blue region">
              <h2>{{region.regionName}}</h2>
              <div v-for="town in region.towns" v-bind:key="town" class="town">
                <p class="town-name"><i>{{town.townName}}</i></p>
                <div class="flex col">
                  <a v-for="store in town.stores" :href="store.link" v-bind:key="store" class="store-link" target="_blank">{{store.name}}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="retailers-inquire" class="container-large">
<img src="@/assets/img/STORE_nanabozho.png" class="nanabozho-img">
      <div class="card card-container bg-teal blue grid grid-2 no-m">

        <img src="@/assets/img/RBS_retailers.png" class="card">
        <div class="flex col justify-content-center retailers-inquire-content">

          <p class="uppercase large-text">Wholesale</p>
          <h3>Interested in carrying our products in your store?</h3>

          <div class="">
            <p>Our interactive games and postcards are a great addition to any bookstore, gift store or game store! We put a lot of thought in our packaging so that our not-always-easy-to-explain products become pretty straightforward to get!</p>
            <div class="buttons">
              <button class="dark full" @click="goToFaireLink()">Find us on Faire</button>
              <button class="dark outline full"  @click="goToMailto()">Inquire</button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Footer :borderTop=true></Footer>
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import Nav from "@/components/Nav.vue";

export default {
  name: 'Retailers',
  props: ['filter'],
  components: {
    Footer,
    Nav
  },
  data () {
    return {
      faireLink: "https://redbluestories.faire.com",
      storeList: [
          {
        regionName: "BC",
        towns: [
          {
            townName: "Squamish",
            stores: [
              {
                name: "Gather Bookshop",
                link: "https://gatherbookshop.com/"
              }
            ]
          },
          {
            townName: "Whistler",
            stores: [
              {
                name: "Armchair Books",
                link: "https://www.whistlerbooks.com/"
              }, {
                name: "Whistler Tourism Centre",
                link: "https://www.whistler.com/whistler-visitor-centre/"
              }
            ]
          },
          {
            townName: "New Westminster",
            stores: [
              {
                name: "Kinder Books",
                link: "https://kinderbooks.ca/"
              },
            ]
          },
            {
            townName: "North Vancouver",
            stores: [
              {
                name: "The Polygon Gallery Store",
                link: "https://store.thepolygon.ca/"
              },
            ]
          },
          {
            townName: "Armstrong",
            stores: [
              {
                name: "Bookish Collective",
                link: "https://bookishcollective.ca/"
              },
            ]
          }
        ],
      },
          {
          regionName: "Alberta",
          towns: [
            {
              townName: "Kananaskis",
              stores: [{
                name: "Pomeroy Kananaskis Mountain Lodge",
                link: "https://pomeroylodging.com/properties/pomeroy-kananaskis-mountain-lodge/"
              }],
            }
          ]
        },
          {
          regionName: "Ontario",
          towns: [
            {
              townName: "Toronto",
              stores: [{
                name: "Toronto Botanical Garden Shop",
                link: "https://torontobotanicalgarden.ca/"
              }],
            }
          ]
        },
      {
          regionName: "Northwest Territories",
          towns: [
            {
              townName: "Norman Wells",
              stores: [{
                name: "Norman Wells Historical Centre",
                link: "https://spectacularnwt.com/amenities/norman-wells-historical-society/"
              }],
            }
          ]
        }]
    }
  },
  computed: {
    StoresCol1() {
      return this.storeList.slice(0,1);
    },
    StoresCol2()
    {
      return this.storeList.slice(1);
    }
  },
  methods: {
    goToFaireLink() {
      window.open(this.faireLink, '_blank');
    },
    goToMailto() {
       window.open('mailto:hello@redbluestories.com');
    }
  },


}
</script>

<style lang="scss" scoped>
@import "../assets/styles/variables";


#retailers-list {
  h2 {
    font-size: 1.6em;
  }

  .region {
    margin-bottom: 1em;
  }

  .town {
    margin-bottom: 1em;
  }


  .town-name {
    font-size: 1.1em;
    padding-bottom: 0.2em;
  }

  a.store-link {
    padding-bottom: 0.4em;
  }
}

#retailers-inquire {
  position: relative;

  .nanabozho-img {
    max-width: 250px;
    position: absolute;
    top: -150px;
    right: 50px;
  }
  .buttons {
    margin-top: .5em;
    button {
      margin: .5em 0em;
    }
  }
}

@media only screen and (min-width: 1440px) {
  .retailers-inquire-content {
    max-width: 80%;
  }
}

@media only screen and (max-width: 1200px) {
  #retailers-inquire {
    .nanabozho-img {
      max-width: 200px;
      position: absolute;
      top: -120px;
      right: 10px;
    }
  }
}

@media only screen and (max-width: 1068px) {
  .grid-2 {
    grid-template-columns: repeat(1, 1fr);
  }

  #retailers-inquire {
    img {
      display: none;
    }
  }
}
</style>